class ImageComparisonSlider extends HTMLElement {
  constructor() {
    super();

    this.scrolling = false;
    this.divider = this.querySelector("[data-divider]");
    this.resizableImage = this.getResizableImage();

    if (!this.divider || !this.resizableImage) return;

    this.divider.addEventListener("mousedown", () => this.enableScrolling());

    ["mouseup", "mouseleave"].forEach((event) => {
      document.body.addEventListener(event, () => this.disableScrolling());
    });

    this.addEventListener("touchstart", this.onTouchStart.bind(this));
    this.addEventListener("touchmove", this.onTouchMove.bind(this));
    this.addEventListener("touchend", this.onTouchEnd.bind(this));

    document.body.addEventListener("mousemove", this.onMouseMove.bind(this));

    window.addEventListener("resize", () => this.onWindowResize());
  }

  onWindowResize() {
    this.resizableImage.style.width = "50%";
    this.divider.style.left = "50%";
  }

  getResizableImage() {
    const images = Array.from(this.querySelectorAll("[data-resize]")).filter(
      (i) => i.offsetWidth > 0 || i.offsetHeight > 0
    );

    if (!images.length) return null;
    else return images[0];
  }

  enableScrolling() {
    this.scrolling = true;
    if (this.dataset.hasLabels) this.classList.remove("hover");
  }

  disableScrolling() {
    this.scrolling = false;
    if (this.dataset.hasLabels) this.classList.add("hover");
  }

  onMouseMove(e) {
    if (!this.scrolling) return;

    const wrapperX = this.getBoundingClientRect().left;

    this.slide(e.pageX - wrapperX);
  }

  onTouchStart(e) {
    document.body.style.overflowY = "hidden";

    const pageX = e.touches[0].pageX;
    const wrapperX = this.getBoundingClientRect().left;

    this.slide(pageX - wrapperX);
  }

  onTouchEnd() {
    document.body.style.overflowY = "auto";
  }

  onTouchMove(e) {
    const pageX = e.touches[0].pageX;
    const wrapperX = this.getBoundingClientRect().left;

    this.slide(pageX - wrapperX);
  }

  slide(x) {
    const position = Math.max(0, Math.min(x, this.offsetWidth)) + "px";

    this.resizableImage.style.width = position;
    this.divider.style.left = position;
  }
}

if (!customElements.get("image-comparison-slider"))
  customElements.define("image-comparison-slider", ImageComparisonSlider);
